module.exports = __webpack_public_path__ + "media/brand_logos/bt_logo-055be949.png";